import { useState } from 'react';
import { LegalMeasureStatus, LegalMeasureType } from '../types/LegalCase';
import type { ErrorField } from '../types/ErrorField';
import type { AddMeasureValue } from './useLegalCaseMeasures';

// Campos com binding próprio na tela; qualquer outro 422 do backend cai no bloco residual.
const INLINE_FIELDS = new Set(['measureType', 'status', 'requestedAt', 'description']);

export const residualErrors = (errorFields: ErrorField[]): ErrorField[] =>
    errorFields.filter((e) => !INLINE_FIELDS.has(e.fieldName));

interface UseLegalCaseMeasureFormArgs {
    onSubmit: (value: AddMeasureValue) => Promise<boolean>;
}

// Estado e handlers do formulário de medida, fora do componente (diretriz do repo: sem
// função dentro de função). Centraliza o reset dos campos ao enviar com sucesso.
export default function useLegalCaseMeasureForm({ onSubmit }: UseLegalCaseMeasureFormArgs) {
    const [measureType, setMeasureType] = useState<LegalMeasureType>(LegalMeasureType.CITATION);
    const [status, setStatus] = useState<LegalMeasureStatus>(LegalMeasureStatus.REQUESTED);
    const [requestedAt, setRequestedAt] = useState('');
    const [description, setDescription] = useState('');

    const reset = () => {
        setMeasureType(LegalMeasureType.CITATION);
        setStatus(LegalMeasureStatus.REQUESTED);
        setRequestedAt('');
        setDescription('');
    };

    // Tipo e status têm default; o formulário está sempre submetível.
    const canSubmit = true;

    const submit = async () => {
        const ok = await onSubmit({ measureType, status, requestedAt, description });
        if (ok) reset();
    };

    return {
        measureType, setMeasureType,
        status, setStatus,
        requestedAt, setRequestedAt,
        description, setDescription,
        canSubmit, submit, reset,
    };
}
